export enum PaymentType {
  OneOffPayment,
  RecurringPayment,
  PaymentOnAccount,
  Free,
}
